import { render, staticRenderFns } from "./about-me-chunk.vue?vue&type=template&id=010c87e6&scoped=true"
import script from "./about-me-chunk.vue?vue&type=script&lang=js"
export * from "./about-me-chunk.vue?vue&type=script&lang=js"
import style0 from "./about-me-chunk.vue?vue&type=style&index=0&id=010c87e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010c87e6",
  null
  
)

export default component.exports